/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLadderChallengeBody
 */
export interface CreateLadderChallengeBody {
    /**
     * The MongoDB ObjectId of the defender participant
     * @type {string}
     * @memberof CreateLadderChallengeBody
     */
    defenderOdId: string;
    /**
     * Optional Unix timestamp for when the match should occur
     * @type {number}
     * @memberof CreateLadderChallengeBody
     */
    scheduledTime?: number;
}

/**
 * Check if a given object implements the CreateLadderChallengeBody interface.
 */
export function instanceOfCreateLadderChallengeBody(value: object): value is CreateLadderChallengeBody {
    if (!('defenderOdId' in value) || value['defenderOdId'] === undefined) return false;
    return true;
}

export function CreateLadderChallengeBodyFromJSON(json: any): CreateLadderChallengeBody {
    return CreateLadderChallengeBodyFromJSONTyped(json, false);
}

export function CreateLadderChallengeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLadderChallengeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'defenderOdId': json['defenderOdId'],
        'scheduledTime': json['scheduledTime'] == null ? undefined : json['scheduledTime'],
    };
}

export function CreateLadderChallengeBodyToJSON(json: any): CreateLadderChallengeBody {
    return CreateLadderChallengeBodyToJSONTyped(json, false);
}

export function CreateLadderChallengeBodyToJSONTyped(value?: CreateLadderChallengeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'defenderOdId': value['defenderOdId'],
        'scheduledTime': value['scheduledTime'],
    };
}

